import { useApiRead } from "source/shared/SessionApiResource"
import {
  transformRequestData,
  transformResponse,
} from "@planningcenter/api-client"
import { routes, buildPath, urlParamsToString } from "source/shared/apiRoutes"
import { API_VERSION } from "source/registrations/api/client"

export const useRegistration = (registrationId, options = {}) => {
  const [path, params] = buildPath(routes.registrations.registration, {
    registrationId,
    ...options,
  })

  const registration = useApiRead(
    urlParamsToString(path, transformRequestData(params)),
    {
      version: API_VERSION,
    },
  )

  return registration.errors ? registration : transformResponse(registration)
}
